'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'bookmark';
var width = 384;
var height = 512;
var aliases = [128278,61591];
var unicode = 'f02e';
var svgPathData = ['M48 48l0 396.4 119.8-69.9 24.2-14.1 24.2 14.1 119.8 69.9 0-396.4-288 0z', 'M192 360.4l24.2 14.1 119.8 69.9 0-396.4-288 0 0 396.4 119.8-69.9 24.2-14.1zM48 500L0 528 0 0 384 0 384 528 192 416 48 500z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBookmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;